import React from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentTab } from "state";
import CustomTab from "components/Tabs/Tab";
import PropertiesManaged from "scenes/Management/PropertiesManaged.jsx/index.jsx";

const ManagementTab = () => {
	const dispatch = useDispatch();
	const [value, setValue] = React.useState(useSelector((state) => state.currentTab["managementTab"]));
	const handleChange = (event, newValue) => {
		setValue(newValue);
		dispatch(setCurrentTab({ name: "managementTab", tab: newValue }));
	};

	const tabComponents = [
		{ Component: <PropertiesManaged />, label: "Properties Managed", index: 0 },
		{ Component: <></>, label: "Bookings", index: 1 },
		{ Component: <></>, label: "Landlords Attached", index: 2 },
		{ Component: <></>, label: "Tenants Attached", index: 3 },
		{ Component: <></>, label: "Reporting", index: 4 },
	];

	return (
		<Box>
			<CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange} />
		</Box>
	);
};

export default ManagementTab;
